import { SVGProps } from 'react';

const SvgPopOut = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.167 10.667H1.833V1.333H6.5V0H1.833C1.093 0 .5.6.5 1.333v9.334C.5 11.4 1.093 12 1.833 12h9.334c.733 0 1.333-.6 1.333-1.333V6h-1.333v4.667ZM7.833 0v1.333h2.394L3.673 7.887l.94.94 6.554-6.554v2.394H12.5V0H7.833Z"
      fill={fill || '#316AE0'}
    />
    <path
      d="M11.167 10.667H1.833V1.333H6.5V0H1.833C1.093 0 .5.6.5 1.333v9.334C.5 11.4 1.093 12 1.833 12h9.334c.733 0 1.333-.6 1.333-1.333V6h-1.333v4.667ZM7.833 0v1.333h2.394L3.673 7.887l.94.94 6.554-6.554v2.394H12.5V0H7.833Z"
      fill="#000"
      fillOpacity={0.2}
    />
  </svg>
);

export default SvgPopOut;
